import {Component, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SpringRestService} from '@aiknow-srl/aik-ngx-http';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {ChangeUserPasswordCB} from '../../ope/auth/ChangeUserPasswordCB';
import {Paths} from "../../utils/Paths";
import {BaseComponent} from "../BaseComponent";
import {EventBusService} from "@aiknow-srl/aik-ngx-eventbus";
import {DashboardService} from "../../services/dashboard/dashboard.service";
import {loadMessages, locale as dxLocale} from "devextreme/localization";
import enMessages from "devextreme/localization/messages/en.json";
import itMessages from "devextreme/localization/messages/it.json";
import themes from "devextreme/ui/themes";
import {SetUserLanguageCB} from "../../ope/user/SetUserLanguageCB";
import {UserOpeService} from "../../services/ope/userOpe.service";
import {ChangePasswordRequest} from "../../models/auth/ChangePasswordRequest";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import {AuthOpeService} from "../../services/ope/authOpe.service";
import {GrpcAuthorizationOPEService} from "../../services/ope/grpc/authorizationOPE.service";
import {AuthStateService} from "../../services/auth/auth-state.service";

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent extends BaseComponent implements OnInit {

  @Output('goToRequest') goToRequest: EventEmitter<string> = new EventEmitter();

  public be: SpringRestService = inject(SpringRestService);
  public dialog: MatDialog = inject(MatDialog);
  public dashboardService: DashboardService = inject(DashboardService);
  public userService: UserOpeService = inject(UserOpeService);
  public authOpeService: AuthOpeService = inject(AuthOpeService);
  env = environment.typeOfEnv;
  languages = this.gmService.localeList;
  changePasswordPopupOpen = false;
  @Input('componentName') componentName?: string;
  @Output('toggleDrawer') toggleDrawer = new EventEmitter;
  protected extEventBus: EventBusService = inject(EventBusService);
  private route: Router = inject(Router);
  @ViewChild('changePassword') private changePassword?: ChangePasswordComponent;

  protected isImpersonating = !!sessionStorage.getItem('impersonationToken');
  private authorizationService = inject(GrpcAuthorizationOPEService);
  private authState = inject(AuthStateService);
  private _disabled!: boolean;

  protected userManualURL: string = 'https://keton.gitbook.io/manuale/';

  get disabled() {
    return this._disabled;
  }

  @Input() set disabled(disabled: boolean) {
    this._disabled = disabled;
  };

  ngOnInit(): void {
    super.ngOnInit();
    this.logger.debug(`${TopbarComponent.name} initialized`);
    this.authorizationService.impersonationEnded$.subscribe(() => {
      this.isImpersonating = false;
    });
  }


  /**
   * Print FE and BE environments in topbar
   */
  printEnvironments(): string {
    let res = '';

    if (environment.typeOfEnv !== 'prod' || this.gmService.envIdLabel !== '') {
      res = `${res} [`;
    }

    if (environment.typeOfEnv !== 'prod') {
      res = `${res} FE: ${environment.typeOfEnv}`;
    }

    if (environment.typeOfEnv !== 'prod' && this.gmService.envIdLabel !== '') {
      res = `${res} -`;
    }

    if (this.gmService.envIdLabel !== '') {
      res = `${res} BE: ${this.gmService.envIdLabel}`;
    }

    if (environment.typeOfEnv !== 'prod' || this.gmService.envIdLabel !== '') {
      res = `${res} ]`;
    }

    return res;

  }

  /**
   * Logout function
   */
  logout = () => {

    this.logger.log('User presses logout button');
    this.logger.log(`Loading route [${Paths.LOGIN}]`);
    this.authState.logout();
  };

  /**
   * Changes the used language
   * @param locale the selected locale
   */
  async changeLanguage(locale: string | undefined) {

    if (!!locale && this.be.getLanguage() !== locale) {

      this.logger.log(`User selects language [${locale}]`);
      const cb = new SetUserLanguageCB();
      cb.i.language = locale;

      this.userService.setUserLanguage(cb).then(
        (_) => {
          this.translate.use(locale);
          this.be.setLanguage(locale);
          localStorage.setItem('language', locale);

          if (locale === "it") {
            loadMessages(itMessages);
            dxLocale("it-IT");
          } else if (locale === "en") {
            loadMessages(enMessages);
            dxLocale("en-GB");
          }
          if (!!this.appService.menuVoice) {
            this.route.navigateByUrl(`${Paths.HOME}/${Paths.EMPTY}`).then(() => {
              this.route.navigateByUrl(`${Paths.HOME}/${this.appService.menuVoice!.name}`)
            });
          }
        }
      );

    }

  }

  /**
   * Opens the change Password dialog
   */
  openChangePassword = () => {

    this.changePasswordPopupOpen = true;

  };
  linkToIubenda = () => {
    window.open(this.appService.IUBENDA_PRIVACY_POLICY_LINK, "_blank");
  };

  printLocaleText(locale: string): string {
    if (locale === 'it') {
      return 'Italiano';
    } else if (locale === 'en') {
      return 'English';
    } else if (locale === 'de') {
      return 'Deutsch';
    } else if (locale === 'es') {
      return 'Español';
    } else if (locale === 'fr') {
      return 'Français';
    }
    return locale;
  }

  changeTheme($event: any) {
    if (!$event.value) {
      themes.current('fluent.saas.light');
    } else {
      themes.current('fluent.saas.dark');
    }
    this.appService.isDarkTheme = $event.value;
    localStorage.setItem("isDarkTheme", $event.value);
  }

  doChangePasswordRequest(body: ChangePasswordRequest) {
    if (body !== null) {

      const cb = new ChangeUserPasswordCB();
      cb.i.newPassword = this.authOpeService.hashPassword(body.newPassword);
      cb.i.oldPassword = this.authOpeService.hashPassword(body.oldPassword);

      this.authOpeService.changeUserPassword(cb).then(_ => {
        this.toastService.openTranslatedSuccessToastMessage('CHANGE_PASSWORD.CHANGE_PASSWORD_SUCCESSFUL');
        this.changePasswordPopupOpen = false;
      }).catch(_ => {
        if (!!this.changePassword) {
          this.changePassword.createRequestSent = false;
        }
      });
    } else {
      this.changePasswordPopupOpen = false;
    }
  }

  onSubMenuShown = (event: any) => {
    event.rootItem.style.pointerEvents = 'none';
  };

  onSubMenuHidden = (event: any) => {
    event.rootItem.style.pointerEvents = 'auto';
  }

  protected readonly window = window;
  protected readonly sessionStorage = sessionStorage;
}
